import styled from "styled-components";

export const SpinnerOverlay = styled.div.attrs((props) => ({
  className: "w-full h-screen flex justify-center items-center",
}))``;

export const SpinnerContainer = styled.div.attrs((props) => ({
  className: "inline-block w-14 h-14 border-2 border-slate-600 rounded-full",
}))``;
